export const titleCase = (str = "") =>
    str.replace(/[_-]/g, ' ')
        .replace(/\w\S*/g, txt => txt[0].toUpperCase() + txt.slice(1).toLowerCase());
